<template>
  <div
    class="card"
    style="border: none; min-height: 100vh"
    id="print-invoice-receipt"
  >
    <div class="card-body d-flex flex-column">
      <div>
        <div class="d-flex justify-content-end">
          <img src="/images/hayandra.jpeg" width="200" />
        </div>

        <div class="text-center">
          <h4
            style="font-weight: bold; ext-transform: uppercase; font-size: 16px"
          >
            <b>LEMBAR TANDA TERIMA </b>
            <!-- <hr
            style="
              border-bottom: 2px solid black;
              margin-right: 200px;
              margin-left: 200px;
              margin-top: 1px;
              margin-bottom: 5px;
            "
          /> -->
          </h4>
        </div>
        <div class="d-flex justify-content-end">
          <div style="font-weight: light" class="mr-25">
            Jakarta, {{ data.date }}
          </div>
        </div>
        <div class="">
          <div class="col pt-0">
            <div style="font-weight: bold">
              Invoice No <span class="ml-2 mr-1">:</span>
              <span style="font-size: 15px">{{ data.po_no }}</span>
            </div>
          </div>
        </div>
        <div class="">
          <div class="col pt-0" style="">
            <span style="">Kepada Yth,</span> <br />
            <span style="">
              {{ data.vendor_name }}
            </span>
          </div>
        </div>
        <div class="row" style="margin-top: 20px">
          <div class="col-11" style="margin-left: 20px">
            <div class="">{{ data.date }}</div>
            <table class="table table-bordered mt-4" style="">
              <tr>
                <th>No</th>
                <th>Item</th>
                <th>Merk</th>
                <th>Jumlah</th>
                <th>Satuan</th>
              </tr>
              <tr v-for="(mdc, index) in data.items_display" :key="mdc.id" class="section-to-keep-together">
                <td>{{ index + 1 }}</td>
                <td>{{ mdc.name }}</td>
                <td>{{ mdc.brand }}</td>
                <td>{{ mdc.quantity }}</td>
                <td>{{ mdc.uom }}</td>
              </tr>
            </table>
          </div>
        </div>

        <div
          class="d-flex justify-content-between col-11 mt-4 section-to-keep-together"
          style="margin-left: 10px"
        >
          <div class="d-flex flex-column align-items-start mt-3">
            <div style="">
              Yang Menyerahkan <br />
              Depo Farmasi Klinik
            </div>
            <!-- <div>
              <div class="signature mt-2" style="height: 150px; width: 150px">
                <img
                  :src="data.submitting_signature"
                  class="ml-2"
                  style="height: 100%; width: 100%; object-fit: contain"
                />
              </div>
            </div>
            <div style="text-align: center">
              <span style="text-align: center; ">{{ data.submitting_name }}</span>
            </div> -->
          </div>
          <div class="d-flex flex-column align-items-start mt-3">
            <div style="">Yang Menerima <br /></div>
            <!-- <div>
              <div class="signature mt-2" style="height: 150px; width: 150px">
                <img
                  :src="data.recipient_signature"
                  class="ml-2"
                  style="height: 100%; width: 100%; object-fit: contain"
                />
              </div>
            </div>
            <div style="text-align: center">
              <div style="text-align: center; ">{{ data.recipient_name }}</div>
            </div> -->
          </div>
        </div>
      </div>
      <div style="margin-bottom: 50px"></div>
      <div
        class="d-flex flex-column align-items-center section-to-keep-together"
        style="opacity: 0.5; margin-top: 10px"
      >
        <div>
          <span
            style="color: #993366"
            class="text-hayandra-primary font-weigh-bold"
            >Address</span
          >
          Jl. Kramat VI No. 11, Jakarta Pusat 10430, Indonesia
        </div>
        <div>
          <span
            style="color: #993366"
            class="text-hayandra-primary font-weigh-bold"
            >Phone</span
          >
          +62 811 935 4000
          <span
            style="color: #993366"
            class="text-hayandra-primary font-weigh-bold"
            >E-mail</span
          >
          info@hayandra.com
        </div>
        <div>
          <span
            style="color: #993366"
            class="text-hayandra-primary font-weigh-bold"
            >Website</span
          >
          www.hayandra.com
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    setting: Object,
  },

  data() {
    return {
      subTotal2: 5400000,
    };
  },

  methods: {
    subtotal(data) {
      let subtotal = 0;
      data.forEach((element) => {
        subtotal += parseInt(element.total_price.replace(/\D/g, ""), 10);
      });
      return subtotal.toLocaleString("id-ID");
    },
    discount(data) {
      let subtotal = 0;
      data.forEach((element) => {
        subtotal += parseInt(element.total_price.replace(/\D/g, ""), 10);
      });
      let discount = (subtotal * this.data.discount) / 100;
      return discount.toLocaleString("id-ID");
    },
    total(data) {
      let subtotal = 0;
      data.forEach((element) => {
        subtotal += parseInt(element.total_price.replace(/\D/g, ""), 10);
      });
      let total = subtotal - (subtotal * this.data.discount) / 100;
      return total.toLocaleString("id-ID");
    },

    btnDownloadOnClick() {
      this.$refs.html2Pdf.generatePdf();
    },

    btnPrintOnClick() {
      this.$htmlToPaper("print-lab-report");
    },

    onProgress($event) {
      console.log("onProgress", $event);
    },

    hasStartedGeneration() {
      console.log("hasStartedGeneration");
    },

    hasGenerated($event) {
      console.log("hasGenerated", $event);
    },
  },
  computed: {
    // totalHarga() {
    //   return this.keranjangs.reduce(function (items, data) {
    //     return items + data.products.harga * data.jumlah_pemesanan;
    //   }, 0);
    // },
    // subTotal() {
    //   return this.data.items_display.reduce(function (items, data) {
    //     // console.log("items", items)
    //     // console.log("data", data.total_price)
    //     let total_price = data.total_price.replace(".", "");
    //     let count = items + parseInt(total_price);
    //     let count_replace = parseInt(count).toLocaleString("id-ID");
    //     return items + parseInt(total_price);
    //   }, 0);
    // },
  },
};
</script>

<style>
/* table.table-bordered {
  border: 1px solid black !important;
  margin-top: 20px;
}
table.table-bordered > thead > tr > th {
  border: 1px solid black !important;
}
table.table-bordered > tbody > tr > td {
  border: 1px solid black !important;
} */
/* .my-table>tbody>tr>td, .mytable>tbody>tr>th, .mytable>tfoot>tr>td, .mytable>tfoot>tr>th, .mytable>thead>tr>td, .mytable>thead>tr>th {
    padding: 12px;
} */
.signature {
  height: 150px;
  width: 150px;
}

.signature img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.text-hayandra-primary {
  color: #993366;
}
</style>

<style>
@media print {
  @page {
    margin-top: 20mm;
    margin-bottom: 20mm;
  }

  /* Tambahkan jarak atas di setiap halaman baru */
  #print-invoice-receipt {
    page-break-inside: avoid;
  }

  .card-body {
    padding-top: 15mm; /* biar isi halaman kedua tidak terlalu mepet ke atas */
  }
}
</style>